import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex';
import { Modal, Card, Table } from 'ant-design-vue';
import {
  Plugin
} from 'vue-fragment';
import VueUeditorWrap from 'vue-ueditor-wrap'
Vue.component('vue-ueditor-wrap', VueUeditorWrap)
Vue.use(Plugin)
Vue.use(Modal)
Vue.use(Card)
Vue.use(Table)
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const role = JSON.parse(localStorage.getItem('role') || '[]');
  const notFound = JSON.stringify(router.options.routes).includes(to.matched[to.matched.length - 1] && to.matched[to.matched.length - 1].path)
  if (!notFound) {
    return next('/404')
  }
  if (((!user.name || user.role === '1') && to.fullPath.includes('/admin/') && to.fullPath !== '/admin/login')) {
    return next('/login')
  }
  if (!user.name && to.fullPath.includes('/me')) {
    return next('/')
  }
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (!to.meta.requireAuth) return next();

  let requireAuth = to.matched.some(record => record.meta.requireAuth);
  if (!requireAuth) return next();
  let filtered = [];
  role.map(item => {
    filtered.push(to.meta.roles.includes(item));
  })
  filtered = filtered.filter(item => !!item);
  if (filtered.length) {
    return next()
  } else {
    return next({
      path: "/403"
    })
  }
})
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js